
export class AppError {
    constructor(public errors?: string[]) {

    }
}
